/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Link, Outlet, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useSocketLogout } from '../hooks/useSocketLogout';
import { usePosSocket } from '../hooks/usePosSocket';
import { usePosNotificationSocket } from '../hooks/usePosNotificationSocket';
import { env } from '../env';
import { ShowNotify } from '../components/fragments/ShowNotify';
import CallStaffAlert from '../components/fragments/CallStaffAlert';
import QrExpiredAlert from '../components/fragments/QrExpiredAlert';
import { useSelector, useDispatch } from 'react-redux';
import { kitchenHandler } from '../redux/handlers';

export default function Layout() {
  useSocketLogout();
  const { businessSlug } = useParams();
  const location = useLocation();
  const [posId, setPosId] = useState('');
  const [callStaffQueue, setCallStaffQueue] = useState([]);
  const [qrExpiredQueue, setQrExpiredQueue] = useState([]);
  const shownQrExpiredIds = useRef(new Set());
  const dispatch = useDispatch();
  const notificationCount = useSelector(state => state.kitchen.notificationCount);
  const notificationPing = useSelector(state => state.kitchen.notificationSocket);
  const hasConnected = useRef(false);
  const navigate = useNavigate();
  const { connect } = usePosNotificationSocket();

  const pathToMenuMap = {
    [`/${businessSlug}`]: 'btn-m1',
    [`/${businessSlug}/notification`]: 'btn-m2',
    [`/${businessSlug}/table`]: 'btn-m3',
    [`/${businessSlug}/bill`]: 'btn-m4',
    [`/${businessSlug}/save`]: 'btn-m5',
    [`/${businessSlug}/menu`]: 'btn-m6',
    [`/${businessSlug}/shop`]: 'btn-m7'
  };

  useEffect(() => {
    const storedPosId = localStorage.getItem('branchPOSId');
    if (storedPosId) {
      setPosId(storedPosId);
    }
  }, []);

  const updateActiveMenu = () => {
    const elems = document.querySelectorAll('.btn-st-m1');
    elems.forEach(el => el.classList.remove('active'));

    const currentMenuId = pathToMenuMap[location.pathname];

    if (currentMenuId) {
      const activeElement = document.getElementById(currentMenuId);
      if (activeElement) {
        activeElement.classList.add('active');
      }
    }
  };

  useEffect(() => {
    updateActiveMenu();
  }, [location.pathname]);

  usePosSocket(posId);

  function handleClickMenu(e) {
    var elems = document.querySelectorAll('.btn-st-m1');
    [].forEach.call(elems, function (el) {
      el.classList.remove('active');
    });
    if (e.target.classList.value === 'btn btn-st-m1') {
      e.target.classList.add('active');
    } else {
      e.target.parentElement.classList.add('active');
    }
  }

  // [system] watch pos_notification socket — queue CALL_STAFF alerts (show one at a time)
  useEffect(() => {
    if (!notificationPing) return;
    try {
      const msg = typeof notificationPing === 'string' ? JSON.parse(notificationPing) : notificationPing;
      if (msg?.type === 'CALL_STAFF') {
        setCallStaffQueue(prev => [...prev, { callType: msg.callType, tableId: msg.tableId, tableName: msg.tableName }]);
      }
      if (msg?.type === 'QR_SESSION_EXPIRED') {
        // [fix] dedup by tableId + show at most one alert (not a queue)
        const tableId = String(msg.tableId ?? '');
        if (tableId && !shownQrExpiredIds.current.has(tableId)) {
          shownQrExpiredIds.current.add(tableId);
          setQrExpiredQueue(prev => prev.length > 0 ? prev : [{ tableId: msg.tableId, tableName: msg.tableName }]);
        }
      }
    } catch {
      // [system] invalid JSON — ignore
    }
  }, [notificationPing]);

  useEffect(() => {
    let interval;

    const checkLocalStorage = () => {
      const branchSellingId = localStorage.getItem('branchPOSSelling');
      if (!(branchSellingId === undefined || branchSellingId === 'undefined' || branchSellingId === null)) {
        clearInterval(interval);

        if (!hasConnected.current) {
          connect(branchSellingId);
          hasConnected.current = true;
        }

        dispatch(kitchenHandler.getTotalUnreadCount(businessSlug, branchSellingId));
      }
    };

    interval = setInterval(checkLocalStorage, 100);
    return () => clearInterval(interval);
  }, [businessSlug, connect, dispatch, notificationPing]);

  return (
    <div className="wrapper">
      {/* [system] call staff queue popup — show one at a time, shift on close */}
      {callStaffQueue.length > 0 && (
        <CallStaffAlert
          data={callStaffQueue[0]}
          queueCount={callStaffQueue.length}
          onClose={() => setCallStaffQueue(prev => prev.slice(1))}
          onGoToBill={(tableId) => navigate(`/${businessSlug}/table`, { state: { callBillTableId: tableId } })}
        />
      )}
      {qrExpiredQueue.length > 0 && callStaffQueue.length === 0 && (
        <QrExpiredAlert
          data={qrExpiredQueue[0]}
          onClose={() => setQrExpiredQueue([])}
        />
      )}
      <div id="content">
        <div className=" h-100vh">
          <div className="block-1">
            <div className="customShow position-relative d-flex flex-column h-100">
              <div className="mb-4 py-2 d-flex justify-content-center">
                <img src="/img/logo-3.png" width="45" alt="Logo" />
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}`} className="btn btn-st-m1 active" id="btn-m1" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-1"></div>
                  <div className="">POS</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link
                  to={`/${businessSlug}/notification`}
                  className="btn btn-st-m1"
                  id="btn-m2"
                  onClick={handleClickMenu}
                >
                  <div className="i-m1 i-m1-2 relative">
                    <ShowNotify countNotify={notificationCount} />
                  </div>
                  <div className="">แจ้งเตือน</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}/table`} className="btn btn-st-m1 " id="btn-m3" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-3"></div>
                  <div className="">โต๊ะ</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}/bill`} className="btn btn-st-m1 " id="btn-m4" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-4"></div>
                  <div className="">บิลขาย</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}/save`} className="btn btn-st-m1 " id="btn-m5" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-5"></div>
                  <div className="">บันทึก</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}/menu`} className="btn btn-st-m1 " id="btn-m6" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-6"></div>
                  <div className="">เมนู</div>
                </Link>
              </div>
              <div className="mb-2">
                <Link to={`/${businessSlug}/shop`} className="btn btn-st-m1 " id="btn-m7" onClick={handleClickMenu}>
                  <div className="i-m1 i-m1-7"></div>
                  <div className="">ร้านค้า</div>
                </Link>
              </div>

              <div className="mt-auto text-center text-muted" style={{ fontSize: '12px', marginBottom: '10px' }}>
                v{env.REACT_APP_VERSION}
              </div>
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
